import Joi from 'joi';

import { createTagsSchema } from '../../../tags/validators/schemas/create-tags.schema';
import { ReportTypeEnum } from '../../enums/report-type.enum';

/**
 * Schema for existing report record update validation.
 */
export const updateReportSchema = () =>
	Joi.object({
		// id - Required and must not be null
		id: Joi.alternatives().conditional(Joi.any().valid(null), {
			then: Joi.invalid(null).messages({
				'any.invalid': 'validations|report-id|cannot-be-null',
			}),
			otherwise: Joi.number().required().messages({
				'any.required': 'validations|report-id|required',
				'number.base': 'validations|report-id|must-be-string',
				'string.empty': 'validations|report-id|must-not-be-empty',
			}),
		}),

		// Name - Required and cannot be null
		name: Joi.alternatives().conditional(Joi.any().valid(null), {
			then: Joi.invalid(null).messages({
				'any.invalid': 'validations|report-name|cannot-be-null',
			}),
			otherwise: Joi.string().required().messages({
				'any.required': 'validations|report-name|required',
				'string.base': 'validations|report-name|must-be-string',
				'string.empty': 'validations|report-name|must-not-be-empty',
			}),
		}),

		type: Joi.alternatives().conditional(Joi.any().valid(null), {
			then: Joi.invalid(null).messages({
				'any.invalid': 'validations|report-type|cannot-be-null',
			}),
			otherwise: Joi.string()
				.valid(...Object.values(ReportTypeEnum))
				.required()
				.messages({
					'any.required': 'validations|report-type|required',
					'any.only': 'validations|report-type|invalid-value',
					'string.base': 'validations|report-type|must-be-string',
				}),
		}),

		// Tags - Optional
		tags: createTagsSchema().messages({
			'array.base': 'validations|report-tags|invalid-value',
		}),
	})
		// Ignore extra fields
		.unknown();
